import {AdvManager, BannerPlacementType} from './types';

export const getAdvManager = (): AdvManager =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any).Ya.Context.AdvManager;

export const log = (message: string, ...args: Array<unknown>) => {
  // eslint-disable-next-line no-console
  console.log(`Yandex AD ${message}`, ...args);
};

export const bindClickLogger = (element: HTMLElement, logClick: () => void) => {
  element.addEventListener('click', logClick, {capture: true, passive: true});
  return () => element.removeEventListener('click', logClick);
};

export const getBannerContainerId = (
  placement: BannerPlacementType,
  position?: number,
) => {
  return ['yan', placement, position].filter(Boolean).join('_');
};

export const AD_AUTOREFRESH_INTERVAL_MS = 30_000;

let adsHeight = 0;

export const forceFooterBottomPadding = (height: number | undefined) => {
  const footer = document.querySelector('footer');

  if (height && footer) {
    adsHeight = height;
    const currentPB = window.getComputedStyle(footer).paddingBottom;
    footer.style.paddingBottom = `calc(${currentPB} + ${adsHeight}px)`;
  }
};

export const removeFooterBottomPadding = () => {
  const footer = document.querySelector('footer');

  if (footer && adsHeight) {
    const currentPB = window.getComputedStyle(footer).paddingBottom;
    footer.style.paddingBottom = `calc(${currentPB} - ${adsHeight}px)`;
  }
};
